/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { Box } from '@mui/material';
import { shallowEqual, useSelector } from 'react-redux';
import { selectExportViewTitle } from '../../../../store';
import appTheme from '../../../common/theme/appTheme.json';

export interface PerformanceOutlookExportPrintModeHeaderProps {
  flightLeg: any;
  totalFlightLegs: number;
}
const PerformanceOutlookExportPrintModeHeader = ({
  flightLeg,
  totalFlightLegs,
}: PerformanceOutlookExportPrintModeHeaderProps) => {
  const exportViewTitle = useSelector(selectExportViewTitle, shallowEqual);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'block',
        '@media print': {
          width: '100%',
          marginBottom: '6px',
        },
      }}
    >
      <Box
        sx={{
          display: 'inline-block',
          fontFamily: appTheme.viasatFontFamilyRegular,
          color: appTheme.primaryTextColor,
          fontSize: '25px',
          lineHeight: '62px',
          width: '50%',
          fontWeight: 500,
          '@media print': {
            lineHeight: '16px',
            color: 'black',
            width: '20%',
            margin: 0,
            fontSize: '16px',
          },
        }}
      >
        Flight leg {flightLeg.legOrder} {flightLeg.origin} - {flightLeg.destination}
      </Box>
      <Box
        sx={{
          display: 'none',
          fontFamily: appTheme.viasatFontFamilyRegular,
          color: appTheme.primaryTextColor,
          fontSize: '25px',
          lineHeight: '62px',
          width: '60%',
          fontWeight: 500,
          '@media print': {
            lineHeight: '16px',
            display: 'inline-block',
            textAlign: 'center',
            color: 'black',
            width: '60%',
            margin: 0,
            fontSize: '16px',
          },
        }}
      >
        {exportViewTitle}
      </Box>
      <Box
        sx={{
          display: 'inline-block',
          fontFamily: appTheme.viasatFontFamilyRegular,
          color: appTheme.primaryTextColor,
          fontSize: '25px',
          lineHeight: '62px',
          fontWeight: 500,
          width: '50%',
          textAlign: 'right',
          paddingRight: '24px',
          boxSizing: 'border-box',
          '@media print': {
            display: 'inline-block',
            width: '20%',
            lineHeight: '16px',
            color: 'black',
            margin: 0,
            fontSize: '16px',
          },
        }}
      >
        Leg {flightLeg.legOrder} of {totalFlightLegs}
      </Box>
    </Box>
  );
};

export default PerformanceOutlookExportPrintModeHeader;
